import TemplateView from "../../../TemplateView";

export default class CreateProjectLightboxHeader extends TemplateView {

    constructor() {
        super(null)
    }

    templateHtml() {
        return '<table class="dialog-header">' +
               '    <tr>' +
               '        <td>' +
               '            <div class="close-button">' +
               '                <div id="closeProjectLightBoxBtn" class="closeButton"></div>' +
               '                <div class="disabledCloseButton"></div>' +
               '            </div>' +
               '' +
               '            <div class="lightBoxTitle">' +
               '                <span class="titlePlaceholder"><%-title%></span>' +
               '            </div>' +
               '        </td>' +
               '    </tr>' +
               '</table>'
    }

    messageKeys() {
        return {
            title: 'project.add.page.title'
        }
    }

    getCloseButtonEl() {
        return this.find('.close-button')
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/createLightbox/project/CreateProjectLightboxHeader.js